let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dehp1")).then(() => parcelRequire('lRmW0'));